import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { Form } from 'react-final-form';
import classNames from 'classnames';
import queryString from 'query-string';
import { t } from 'ttag';

import { editProduct, myClothes, promotions } from '@urls';
import { Button } from '@ui/Button';
import MarkSoldButton from '@containers/MarkSoldButton';


import s from './ProductDetailsSellerActions.sss';

interface Props {
  className?: string,
  productId: number,
  isProductHidden: boolean,
  isCanBePromoted: boolean,
  isCanBeReserved: boolean,
  isCanBeUnReserved: boolean,
  isCanBeFreePushups: boolean,
  freePushupAvailable: boolean,
  isCanBeActivated: boolean,
  isCanBeDeactivated: boolean,
  isPromoActionCanBeAdded: boolean,
  isPromoActionCanBeEdited: boolean,
  isCanBeAddedToSwap: boolean,
  isCanRemoveFromSwap: boolean,
  isCanMarkAsSold: boolean,
  isCanBeEdited: boolean,
  onReserve: () => void,
  onUnReserve: () => void,
  onFreePushup: () => void,
  onActivate: () => void,
  onDeactivate: () => void,
  onAddPromoAction: () => void,
  onEditPromoAction: () => void,
  onAddToSwap: () => void,
  onRemoveFromSwap: () => void,
}

export const ProductDetailsSellerActions: React.FC<Props> = ({
  className,
  productId,
  isProductHidden,
  isCanBePromoted,
  isCanBeReserved,
  isCanBeUnReserved,
  isCanBeFreePushups,
  freePushupAvailable,
  isCanBeActivated,
  isCanBeDeactivated,
  isPromoActionCanBeAdded,
  isPromoActionCanBeEdited,
  isCanBeAddedToSwap,
  isCanRemoveFromSwap,
  isCanMarkAsSold,
  isCanBeEdited,
  onReserve,
  onUnReserve,
  onFreePushup,
  onActivate,
  onDeactivate,
  onAddPromoAction,
  onEditPromoAction,
  onAddToSwap,
  onRemoveFromSwap,
}) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <ul className={classNames(s.list, className)}>
      {!isProductHidden && (
        <>
          {isCanBePromoted && (
            <li className={s.item}>
              <Button to={{
                pathname: promotions,
                search: queryString.stringify({
                  next: location.pathname,
                })
              }}>
                {t`Рекламувати`}
              </Button>
            </li>
          )}

          {isCanBeReserved && (
            <li className={s.item}>
              <Form
                onSubmit={onReserve}
                render={({ handleSubmit, submitting }) => (
                  <form onSubmit={handleSubmit}>
                    <Button
                      type='submit'
                      theme='secondary'
                      disabled={submitting}
                    >
                      {t`Поставити на резерв`}
                    </Button>
                  </form>
                )}
              />
            </li>
          )}

          {isCanBeUnReserved && (
            <li className={s.item}>
              <Form
                onSubmit={onUnReserve}
                render={({ handleSubmit, submitting }) => (
                  <form onSubmit={handleSubmit}>
                    <Button
                      type='submit'
                      theme='secondary'
                      disabled={submitting}
                    >
                      {t`Зняти з резерву`}
                    </Button>
                  </form>
                )}
              />
            </li>
          )}

          {isCanBeFreePushups && (
            <li className={s.item}>
              <Form
                onSubmit={onFreePushup}
                render={({ handleSubmit, submitting }) => (
                  <form onSubmit={handleSubmit}>
                    <Button
                      type='submit'
                      theme='secondary'
                      disabled={!freePushupAvailable || submitting}
                    >
                      {t`Безкоштовно підняти`}
                    </Button>
                  </form>
                )}
              />
            </li>
          )}
        </>
      )}

      {isCanBeActivated && (
        <li className={s.item}>
          <Form
            onSubmit={onActivate}
            render={({ handleSubmit, submitting }) => (
              <form onSubmit={handleSubmit}>
                <Button
                  type='submit'
                  disabled={submitting}
                >
                  {t`Активувати`}
                </Button>
              </form>
            )}
          />
        </li>
      )}

      {isCanBeDeactivated && (
        <li className={s.item}>
          <Form
            onSubmit={onDeactivate}
            render={({ handleSubmit, submitting }) => (
              <form onSubmit={handleSubmit}>
                <Button
                  type='submit'
                  theme='secondary'
                  disabled={submitting}
                >
                  {t`Деактивувати`}
                </Button>
              </form>
            )}
          />
        </li>
      )}

      {isPromoActionCanBeAdded && (
        <li className={s.item}>
          <Form
            onSubmit={onAddPromoAction}
            render={({ handleSubmit, submitting }) => (
              <form onSubmit={handleSubmit}>
                <Button
                  type='submit'
                  theme='secondary'
                  disabled={submitting}
                >
                  {t`Додати акцію`}
                </Button>
              </form>
            )}
          />
        </li>
      )}

      {isPromoActionCanBeEdited && (
        <li className={s.item}>
          <Form
            onSubmit={onEditPromoAction}
            render={({ handleSubmit, submitting }) => (
              <form onSubmit={handleSubmit}>
                <Button
                  type='submit'
                  theme='secondary'
                  disabled={submitting}
                >
                  {t`Редагувати акцію`}
                </Button>
              </form>
            )}
          />
        </li>
      )}

      {isCanBeAddedToSwap && (
        <li className={s.item}>
          <Form
            onSubmit={onAddToSwap}
            render={({ handleSubmit, submitting }) => (
              <form onSubmit={handleSubmit}>
                <Button
                  type='submit'
                  theme='secondary'
                  disabled={submitting}
                >
                  {t`Додати до SWAP-паті`}
                </Button>
              </form>
            )}
          />
        </li>
      )}

      {isCanRemoveFromSwap && (
        <li className={s.item}>
          <Form
            onSubmit={onRemoveFromSwap}
            render={({ handleSubmit, submitting }) => (
              <form onSubmit={handleSubmit}>
                <Button
                  type='submit'
                  theme='secondary'
                  disabled={submitting}
                >
                  {t`Видалити зі SWAP-паті`}
                </Button>
              </form>
            )}
          />
        </li>
      )}

      {isCanMarkAsSold && (
        <li className={s.item}>
          <MarkSoldButton
            productId={productId}
            onCloseSuccessModal={() => history.replace(myClothes)}
          >
            {({ openModal }) => (
              <Button
                theme='secondary'
                onClick={openModal}
              >
                {t`Відмітити проданим`}
              </Button>
            )}
          </MarkSoldButton>
        </li>
      )}

      {isCanBeEdited && (
        <li className={s.item}>
          <Button
            theme='secondary'
            to={generatePath(editProduct, { productId })}
          >
            {t`Редагувати`}
          </Button>
        </li>
      )}
    </ul>
  );
};
